export const ENV_SVI = 'SVI'
export const ENV_TST = 'TST'
export const ENV_PRE = 'PRE'
export const ENV_PRD = 'PRD'

export const mainport = 'col-xl-7 col-md-10 col-12'
